import { makeAutoObservable, runInAction } from 'mobx';
import { GameInvitation, InvitableFriend } from '../models/GameInvitation';
import { agent } from '../api/agent';

export default class GameInvitationStore {
  invitableFriends: InvitableFriend[] = [];
  gameInvitations: GameInvitation[] = [];
  loading = false;
  submitting = false;

  constructor() {
    makeAutoObservable(this);
  }

  loadInvitableFriends = async (gameId: string) => {
    this.loading = true;
    try {
      const friends = await agent.GameInvitations.getInvitableFriends(gameId);
      runInAction(() => {
        this.invitableFriends = friends;
        this.loading = false;
      });
    } catch (error) {
      console.error('Error loading invitable friends:', error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };

  loadGameInvitations = async (gameId: string) => {
    this.loading = true;
    try {
      const invitations = await agent.GameInvitations.getGameInvitations(gameId);
      runInAction(() => {
        this.gameInvitations = invitations;
        this.loading = false;
      });
    } catch (error) {
      console.error('Error loading game invitations:', error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };

  sendInvitations = async (gameId: string, userIds: string[]) => {
    this.submitting = true;
    try {
      await agent.GameInvitations.sendInvitations(gameId, userIds);
      runInAction(() => {
        this.submitting = false;
      });
      // Reload invitations and friends after sending
      await this.loadGameInvitations(gameId);
      await this.loadInvitableFriends(gameId);
      return true;
    } catch (error) {
      console.error('Error sending invitations:', error);
      runInAction(() => {
        this.submitting = false;
      });
      return false;
    }
  };

  clearInvitableFriends = () => {
    this.invitableFriends = [];
  };

  clearGameInvitations = () => {
    this.gameInvitations = [];
  };
}